import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import images from '../../../images';
import Lesson from '../../../common/Lesson';
import { __ } from '../../../locales';
import { iframeCall, } from '../../../helpers/iframeHelper';
import { trackEvent } from '../../../helpers/common';
import events from '../../../app/events';
import CustomButton from '../../../common/CustomButton';

const Container = styled.div`
  padding: 25px 0px;
  padding-right: 0;
`;

const Content = styled.ul`
  height: 100px;
  overflow-x: scroll;
  display: flex;
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: center;
  margin-right: -12px;
  margin-left: -12px;
  padding-left: 12px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Title = styled.h2`
  font-weight: bold;
  margin-bottom: 10px;
`;

const BodyText = styled.p`
  margin-bottom: 5px;
  line-height: 1.4em;
`;

const Done = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
  margin-right: 8px;
  margin-top: 4px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: url(${images.done});
`;

const SectionTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TakeTheQuizContainer = styled.div`
  display: block;
  padding: 10px 0px;
`;

const RecyclingFundamentals = ({
  lessons,
  quizData,
  hasPassedRfQuiz,
  accountId,
  viewedRFLessons,
  mainColor
}) => {
  const { push } = useHistory();
  const lessonRef = useRef();
  const { rfQuiz } = quizData || {};
  const lessonContentRef = useRef();

  // useEffect(() => {
  //   if (!didCompleteLessons && lessons) {
  //     const nextAvailableLesson = Object
  //       .keys(lessons)
  //       .map((key) => lessons[key])
  //       .find(({ done }) => !done);

  //     if (lessonContentRef.current) {
  //       lessonContentRef.current.scroll(
  //         nextAvailableLesson.oidx * 315,
  //         0
  //       );
  //     }
  //   }
  // }, []);

  const onClick = (id) => {
    const lesson = Object
      .keys(lessons)
      .map((key) => lessons[key])
      .find(({ id: lId }) => id === lId);
    trackEvent(
      events.DZ_HOME_RF_ITEM_TAP,
      {
        activity_id: lesson.activity.coachable_id,
        campaign_id: id
      }
    );
    push(`/lesson-details/rf/${id}`, { ...lesson });
  };

  const resumeQuiz = () => {
    const nextIndex = Object
      .keys(rfQuiz)
      .map((key) => rfQuiz[key])
      .findIndex(({ answered }) => !answered);
    trackEvent(events.DZ_RF_TAKE_QUIZ_CTA_TAP);
    push(`/quiz/rf/${(nextIndex === -1) ? 0 : nextIndex}`);
  };

  const createAccount = () => {
    trackEvent(events.DZ_HOME_SIGNUP_CTA_TAP);
    iframeCall('dzSignup');
  };

  const didCompleteLessons = Object
    .keys(lessons)
    .map((key) => lessons[key])
    .every(({ done }) => done)
    || (window.badges && window.badges.find(({ name }) => name === 'dz_recycling_fundamentals')?.acquired);

  const didCompleteQuiz = (window.badges && window.badges.length && window.badges.find(({ name }) => name === 'dz_recycling_fundamentals')?.acquired) || hasPassedRfQuiz || rfQuiz
    .every(({ answered }) => answered);

  return (
    <Container>
      <SectionTitleContainer>
        <Title
          style={{
            fontSize: didCompleteLessons && didCompleteQuiz ? 19 : 24
          }}
        >
          {__('app.recycling_fundamentals')}
        </Title>
        {
          didCompleteLessons
          && didCompleteQuiz
          && (
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
              <Done />
              <h2
                style={{
                  fontSize: 18,
                  color: process.env.REACT_APP_COLOR_RC_GREEN
                }}
              >
                {__('app.completed')}
              </h2>
            </div>
          )
        }
      </SectionTitleContainer>
      <BodyText>
        {__('app.earn_a_badge_and_be_a_more_confident')}
      </BodyText>
      {
        lessons
          ? (
            <Content aria-label="Recycling Fundamentals lessons list" ref={lessonContentRef}>
              {
                Object
                  .keys(lessons)
                  .map((key) => lessons[key])
                  .sort((a, b) => viewedRFLessons.includes(a?.id)
                    - viewedRFLessons.includes(b?.id))
                  .map(({
                    title,
                    id,
                    done
                  }) => (
                    <Lesson
                      key={id}
                      id={id}
                      title={title}
                      onClick={() => {
                        onClick(id);
                      }}
                      data={lessons[id]}
                      status={done ? 'done' : 'ready'}
                      type="RF"
                      ref={lessonRef}
                    />
                  ))
              }
            </Content>
          ) : null
      }
      {
        lessons
          && rfQuiz
          && didCompleteLessons
          && !hasPassedRfQuiz
          && !accountId
          ? (
            <TakeTheQuizContainer>
              <button
                type="button"
                className="btn filled royal"
                onClick={createAccount}
              >
                {__('app.please_create_account_to_continue')}
              </button>
            </TakeTheQuizContainer>
          ) : null
      }

      {
        lessons
          && rfQuiz
          && didCompleteLessons
          && !hasPassedRfQuiz
          && accountId
          ? (
            <TakeTheQuizContainer>
              <CustomButton
                type="button"
                className="btn filled royal"
                onClick={resumeQuiz}
                style={{ background: mainColor || '#002391' }}
              >
                {__('app.take_the_quiz')}
              </CustomButton>
            </TakeTheQuizContainer>
          ) : null
      }
    </Container>
  );
};

const mapStateToProps = (store) => ({
  mainColor: store.app?.mainColor || '#002391',
});

export default connect(mapStateToProps, null)(RecyclingFundamentals);
